import _ from 'lodash';
import { arrayAny } from '../../utils/arrayUtils';
import { useEffect } from 'react';

export const DocTypeSelector = ({ docTypes, selectedDocType, onDocTypeSelect }) => {

    const firstDocType = () => {
        if (docTypes && Object.hasOwn(docTypes, "documentTypes")) {
            return arrayAny(docTypes.documentTypes) ? _.first(_.sortBy(docTypes.documentTypes, dt => dt.documentType)) : null
        }
        return null;
    };

    const defaultDocType = firstDocType();
    
    useEffect(() => {
        if(selectedDocType && selectedDocType.description === "" && defaultDocType){
            onDocTypeSelect(defaultDocType);
        }
    }, [selectedDocType, defaultDocType, onDocTypeSelect]);

    return defaultDocType ? (

        <div className="mb-3 d-md-flex fw-bold">
            <div className="dropdown-toggle">
                <div style={{ cursor: "pointer" }}
                    data-bs-toggle="dropdown"
                    className="text-decoration-none text-dark">
                    <i className="far fa-file fa-fw text-dark text-opacity-50 me-1" />
                    {(selectedDocType && selectedDocType.description ? selectedDocType : defaultDocType).documentType}
                    <b className="ms-5px caret"></b>
                </div>

                <div className="dropdown-menu dropdown-menu-start">
                    {_.orderBy(docTypes.documentTypes, dt => dt.documentType).map((dt, i) => ( // For each docType...
                        <div
                            onClick={() => onDocTypeSelect(dt)} style={{ cursor: "pointer" }}
                            key={`docId-${i}`}
                            className="dropdown-item">
                            <i className="far fa-file fa-fw fa-lg text-gray-500 me-1" />{dt.documentType}
                        </div>

                    ))}
                </div>
            </div>
        </div>
    )
        :
        (<>Loading...</>);
};